import { useState, useEffect } from "react";
import { useGetAllUserQuery } from "src/services/UserService";

const useUser = () => {
    const [user, setUser] = useState<any[]>([]);
    const [isDataLoading, setIsDataLoading] = useState(true);

    const { data, isLoading, isFetching } = useGetAllUserQuery("");

    useEffect(() => {
        if (isLoading || isFetching) {
            setIsDataLoading(true);
        } else {
            const result: any[] = data?.data;
            setUser(result || []);
            setIsDataLoading(false);
        }
    }, [data, isLoading, isFetching]);

    return { user, isDataLoading };
};

export default useUser;
